var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.showPagination)?_c('v-flex',{staticClass:"text-xs-center"},[_c('p',[_vm._v(_vm._s(_vm.getPaginationIndex))]),_vm._v(" "),(_vm.showPaginationButton)?_c('v-btn',{attrs:{"color":"primary","outline":""},on:{"click":_vm.updateRequestsPaginationIndex}},[_vm._v("\n      Show more\n    ")]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4e9dc42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/RequestListPagination.vue
// module id = null
// module chunks = 